import React, { Fragment, Suspense } from "react";
import Preloader from "../elements/Preloader";
import SEO from "../components/SEO";
import seoData from "../data/seoData";
const Breadcrumb = React.lazy(() => import("../components/Breadcrumb"));
const DocumentList = React.lazy(() => import("../components/DocumentList"));
const FooterBottomOne = React.lazy(() => import("../components/FooterBottomOne"));
const Footer = React.lazy(() => import("../components/Footer"));
const Navbar = React.lazy(() => import("../components/Navbar"));
const SearchPopup = React.lazy(() => import("../elements/SearchPopup"));

const Document = () => {
    return (
        <>
            <SEO {...seoData.documents} />
            <Fragment>
                <Suspense fallback={<Preloader />}>
                    <SearchPopup />
                    <Navbar />
                    <Breadcrumb title={"Dökümanlar"} h1={true} />
                    <div className='pd-top-120 pd-bottom-120'>
                        <DocumentList />
                    </div>
                    <Footer />
                    <FooterBottomOne />
                </Suspense>
            </Fragment>
        </>
    )
}

export default Document